import React from 'react';
import { ShieldIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { trackAddToCart } from '../utils/pixel';
export function OfferCTA() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section id="oferta" className="relative py-24 px-6 z-10 bg-gradient-to-b from-night-900 via-night-800 to-night-900 border-t border-gold-500/20" data-id="element-138">
      <div ref={ref} className={`max-w-4xl mx-auto text-center section-reveal ${isVisible ? 'visible' : ''}`} data-id="element-139">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-cream-100 mb-6 leading-tight" data-id="element-140">
          Recupera tus noches y tu energía por menos de lo que cuesta una cena.
        </h2>

        <p className="text-xl text-cream-200 mb-12" data-id="element-141">
          Obtén el sistema completo "Ritual de Paz Nocturna" hoy mismo.
        </p>

        <div className="glass-card max-w-lg mx-auto p-10 rounded-3xl border-gold-500/30 mb-10 relative overflow-hidden" data-id="element-142">
          {/* Subtle glow effect behind price */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gold-500/10 blur-3xl rounded-full pointer-events-none" data-id="element-143" />

          <div className="relative z-10" data-id="element-144">
            <span className="inline-block px-4 py-1 rounded-full bg-gold-500/20 text-gold-400 text-sm font-bold uppercase tracking-widest mb-4" data-id="element-145">
              Precio Especial
            </span>
            <div className="text-3xl md:text-4xl text-cream-200/50 line-through font-heading mb-2" data-id="element-146">
              $18.00
            </div>
            <div className="text-7xl md:text-8xl font-heading font-bold text-cream-100 mb-3" data-id="element-147">
              $6.39
            </div>
            <span className="inline-block px-5 py-2 rounded-full bg-green-500/20 text-green-400 text-lg font-bold mb-8" data-id="element-148">
              ¡Ahorra 64%!
            </span>

            <a href="https://guiasparavivir.com/cart/52479158714657:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="block w-full bg-gold-500 hover:bg-gold-400 text-night-900 font-bold text-lg md:text-xl py-5 px-8 rounded-full transition-all duration-300 transform hover:scale-105 animate-glow-pulse shadow-xl text-center no-underline" aria-label="Comprar Ritual de Paz Nocturna" data-id="element-149">
              ¡SÍ, QUIERO DORMIR EN PAZ!
              <span className="block text-sm font-medium opacity-80 mt-1" data-id="element-150">
                DESCARGAR AHORA
              </span>
            </a>
          </div>
        </div>

        <div className="flex items-center justify-center gap-3 text-cream-200/80 text-sm md:text-base" data-id="element-151">
          <ShieldIcon className="w-5 h-5 text-gold-400" data-id="element-152" />
          <span data-id="element-153">Acceso inmediato en PDF. Pago seguro y privado.</span>
        </div>
      </div>
    </section>;
}